import { render, staticRenderFns } from "./WpsEdit.vue?vue&type=template&id=d9dd052c"
import script from "./WpsEdit.vue?vue&type=script&lang=js"
export * from "./WpsEdit.vue?vue&type=script&lang=js"
import style0 from "./WpsEdit.vue?vue&type=style&index=0&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports